import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';

import Dialog from 'src/components/dialog/Dialog';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
    isCanceling: boolean;
};

export default function CancelTourConfirmModal({ open, onClose, onConfirm, isCanceling }: Props) {
    return (
        <Dialog
            open={open}
            onClose={() => {
                if (!isCanceling) {
                    onClose();
                }
            }}
            maxWidth="xs"
            fullWidth
            aria-labelledby="cancel-tour-dialog-title"
        >
            <DialogTitle id="cancel-tour-dialog-title">Cancel tour?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to cancel this tour? This cannot be undone.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    disabled={isCanceling}
                    data-testid="cancel-tour-confirm-modal-dismiss-button"
                >
                    Keep tour
                </Button>
                <LoadingButton
                    variant="contained"
                    color="error"
                    onClick={() => void onConfirm()}
                    loading={isCanceling}
                    data-testid="cancel-tour-confirm-modal-confirm-button"
                >
                    Cancel tour
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
